import {
  TFirebaseMediaLibraryItemReady,
  TFirebaseQuestion,
} from '@chancer/common/lib/interfaces/firestore/FirestoreClientInterfaces';

export const applyMediaToLink = (
  link: TFirebaseQuestion['link'],
  media: TFirebaseMediaLibraryItemReady,
) => ({
  ...link,
  url: media.url,
  caption: media.title,
  text: media.url.includes('spotify.com')
    ? 'Listen'
    : media.url.includes('tiktok.com') ||
        media.url.includes('instagram.com') ||
        media.url.includes('youtube.com') ||
        media.url.includes('youtu.be')
      ? 'Watch More'
      : 'Read More',
  ...(media.imageThumb
    ? {
        image: {
          url: media.imageThumb,
        },
      }
    : {}),
  publisher: {
    caption: media.siteName ?? media.domain,
    ...(media.icon ? {image: {url: media.icon}} : {}),
  },
});
